import React from 'react'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__exhibitionMode.jcss'
import { Typography } from 'atoms/Typography'
import { SwitchButton } from '../../../atoms/SwitchButton'

const DeviceSettingsExhibitionMode = (p_: {
    enabled: boolean
    value: boolean
    className: string | object
    onChange: (value: any, field: string) => void
    type: string
}) => {
    if (!p_.enabled) {
        return null
    }

    return (
        <div className={cn(p_.className)}>
            <div className={styles.switchWrapper}>
                <SwitchButton
                    checked={p_.value}
                    onChange={() => {
                        p_.onChange(!p_.value, 'exhibitionModeEnabledQ')
                    }}
                    className={`test-settings-toggle_${p_.value ? 'enabled' : 'disabled'}`}
                />
                <div className={cn(styles.switchCaption)}>
                    <Typography type="title">{translate('activate')}</Typography>
                </div>
            </div>
        </div>
    )
}

DeviceSettingsExhibitionMode.defaultProps = {
    value: false,
}

export default React.memo(DeviceSettingsExhibitionMode)
